module.exports = __webpack_public_path__ + "static/laptop-34b6d1870af4fc912dae3808c1445d7a.png";